import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { accountInfoFactory } from './accountInfo.factory';
import { agreementFactory } from './agreement.factory';
import { campaignsFactory } from './campaigns.factory';
import { couponFactory } from './coupon.factory';
import { curationsFactory } from './curations.factory';
import { joinFactory } from './join.factory';
import { linkFactory } from './link.factory';
import { mypageFactory } from './mypage.factory';
import { productsFactory } from './products.factory';
import { profileFactory } from './profile.factory';
import { registrationFactory } from './registration.factory';
import { revenueFactory } from './revenue.factory';
import { salesRankingFactory } from './salesRanking.factory';
import { snapLikeFactory } from './snap-like.factory';

export const curatorQueries = mergeQueryKeys(
  accountInfoFactory,
  agreementFactory,
  campaignsFactory,
  curationsFactory,
  joinFactory,
  mypageFactory,
  productsFactory,
  profileFactory,
  registrationFactory,
  revenueFactory,
  linkFactory,
  salesRankingFactory,
  couponFactory,
  snapLikeFactory,
);

// Export type for usage in components
export type CuratorQueries = typeof curatorQueries;
